export enum CastStatus {
    active = 'Active',
    withdrawn = 'Withdrawn'
}
